module.exports = __webpack_public_path__ + "static/media/purse-showcase.cc000ac2.jpg";